import React, { Component } from "react";
import { connect } from "react-redux";
import * as actionCreater from "../../actions/authActions";
import { withRouter, Link } from "react-router-dom";
import InfoBanner from "./InfoBanner";
import { withCookies } from "react-cookie";
import AuthErrorIndicator from "./AuthErrorIndicator";
import { strings } from "../../resources/Strings";
import TopBanner from "../layout/TopBanner";
import Encryptor from "simple-encryptor";
import { SSOCookie } from "../../lib/encrypt";

import { store as notificationMessageStore } from "react-notifications-component";
import ga4 from "../../analytics/ga4/ga4";
class SignIn extends Component {
  state = {
    userName: null,
    password: null,
    clientId: null,
    pswdInputType: "password",
    userNameError: null,
    passwordError: null,
    formError: null,
  };

  handleChange = (e) => {
    this.setState({
      [e.target.id]: e.target.value,
    });
  };

  validate = () => {
    let isValid = true;
    // Check fields for empty values
    if (!this.state.userName) {
      this.setState({
        userNameError: strings.signIn.nameRequired,
      });
      isValid = false;
    } else {
      this.setState({
        userNameError: null,
      });
    }

    if (!this.state.password) {
      this.setState({
        passwordError: strings.signIn.passwordRequired,
      });
      isValid = false;
    } else {
      this.setState({
        passwordError: null,
      });
    }

    if (isValid) {
      this.setState({
        userNameError: null,
        passwordError: null,
      });
    }

    return isValid;
  };

  handleSubmit = (e) => {
    e.preventDefault();

    this.props.authReset();

    if (this.validate()) {
      const rememberme = document.getElementById("rememberme");
      const { cookies } = this.props;
      if (rememberme.checked) {
        cookies.set("username", this.state.userName);
      } else {
        cookies.remove("username");
      }

      this.setSSOcookie();

      // Redirect to destination page after login info
      const { history } = this.props;

      this.props.authenticate(this.state, history, cookies);
      ga4.set("user_properties", { user_id: this.state.userName });
      ga4.set("custom_username", this.state.userName);
      ga4.set("custom_environment", process.env.REACT_APP_GA_ENV);
      ga4.set("user_properties", { user_id: this.state.userName });
      ga4.event("login", { method: "LDAP" });
      console.log("LDAP login complete GA4");
    }
  };

  setSSOcookie = () => {
    const { cookies } = this.props;
    let encryptor = new Encryptor(process.env.REACT_APP_CK);

    const encrypted = encryptor.encrypt({
      u: this.state.userName,
    });

    // store creds for sso login
    cookies.set(SSOCookie.Name, encrypted);
  };

  passwordShowHide = (e) => {
    e.preventDefault();

    this.setState({
      pswdInputType: this.state.pswdInputType === "text" ? "password" : "text",
    });
  };

  componentDidMount() {
    notificationMessageStore.counter = 0;

    this.props.authReset();

    this.setState({
      clientId: process.env.REACT_APP_PT,
    });

    // Remember me
    const { cookies } = this.props;
    const name = cookies.get("username");
    if (name) {
      this.setState({
        userName: cookies.get("username"),
      });

      let userNameInput = document.getElementById("userName");
      if (userNameInput) {
        userNameInput.value = name;
      }

      // set Remember me for next time
      const rememberme = document.getElementById("rememberme");
      rememberme.checked = true;
    }
  }

  render() {
    return (
      <React.Fragment>
        <TopBanner />
        <div className="form-wrapper mt-3">
          <form
            className="form-signin text-left card mt-2 border bg-transparent"
            onSubmit={this.handleSubmit}
          >
            <div className="form-group h5">{strings.signIn.header}</div>
            <div className="form-group">
              <label htmlFor="userName">{strings.signIn.userNameLabel}</label>
              <Link to={"/forgotusername"} className="float-right">
                {strings.signIn.forgotUsername}
              </Link>
              <input
                type="text"
                className="form-control"
                id="userName"
                aria-describedby="usernameHelp"
                placeholder={strings.signIn.userNamePlaceholder}
                onChange={this.handleChange}
                disabled={this.props.loading ? true : false}
              />
              <div className="invalid-feedback d-block">
                {this.state.userNameError}
              </div>
            </div>
            <div className="form-group position-relative">
              <label htmlFor="password">{strings.signIn.passwordLabel}</label>
              <Link to={"/forgotpassword"} className="float-right">
                {strings.signIn.forgotPassword}
              </Link>
              <input
                type={this.state.pswdInputType}
                className="form-control password-with-eye"
                id="password"
                placeholder={strings.signIn.passwordPlaceholder}
                onChange={this.handleChange}
                disabled={this.props.loading ? true : false}
              />
              <span
                className={
                  "password-show-hide " +
                  (this.state.pswdInputType === "password"
                    ? "password"
                    : "text")
                }
                onClick={this.passwordShowHide}
              />
              <div className="invalid-feedback d-block">
                {this.state.passwordError}
              </div>
            </div>

            <AuthErrorIndicator formError={this.state.formError} />

            <div className="input-group d-inline-block">
              <input
                id="rememberme"
                type="checkbox"
                className="float-left mb-1 mt-1"
              />
              <span className="ml-4 d-block remember-me">
                {strings.signIn.rememberMe}
              </span>
            </div>
            <button
              type="submit"
              className="btn btn-lg btn-primary btn-block mt-2"
            >
              {strings.signIn.submitText}
            </button>
            <div className="text-center pt-4 pb-3 register-now">
              {strings.formatString(
                strings.signIn.or,
                <Link to={"/registration"} onClick={() => {}}>
                  {strings.signIn.register}
                </Link>
              )}
            </div>
          </form>

          <InfoBanner />
        </div>
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    authenticate: (credentials, redirectInfo, cookies) => {
      dispatch(actionCreater.authenticate(credentials, redirectInfo, cookies));
    },
    authReset: () => {
      dispatch(actionCreater.authReset());
    },
  };
};

export default withRouter(
  withCookies(
    connect(
      null,
      mapDispatchToProps
    )(SignIn)
  )
);
